import {
  Grid,
  Typography,
  Modal,
  Button,
} from '@mui/material';
import CaliforniaSupplySelectForm from './stateForms/californiaSupplySelectForm';
import ColoradoSupplySelectForm from './stateForms/coloradoSupplySelectForm';
import ConnecticutSupplySelectForm from './stateForms/connecticutSupplySelectForm';
import FloridaSupplySelectForm from './stateForms/floridaSupplySelectForm';
import GeorgiaSupplySelectForm from './stateForms/georgiaSupplySelectForm';
import IndianaSupplySelectForm from './stateForms/indianaSupplySelectForm';
import KentuckySupplySelectForm from './stateForms/kentuckySupplySelectForm';
import MichiganSupplySelectForm from './stateForms/michiganSupplySelectForm';
import MinnesotaSupplySelectForm from './stateForms/minnesotaSupplySelectForm';
import MississippiSupplySelectForm from './stateForms/mississippiSupplySelectForm';
import MissouriSupplySelectForm from './stateForms/missouriSupplySelectForm';
import NewJerseySupplySelectForm from './stateForms/newJerseySupplySelectForm';
import NewYorkSupplySelectForm from './stateForms/newYorkSupplySelectForm';
import NorthCarolinaSupplySelectForm from './stateForms/northCarolinaSupplySelectForm';
import SouthCarolinaSupplySelectForm from './stateForms/southCarolinaSupplySelectForm';
import TennesseeSupplySelectForm from './stateForms/tennesseeSupplySelectForm';
import WashingtonSupplySelectForm from './stateForms/washingtonSupplySelectForm';
import WisconsinSupplySelectForm from './stateForms/wisconsinSupplySelectForm';

export default function SupplySelectModal({
  isOpen,
  handleClose,
  jid,
  supplySelections,
  setForm,
}) {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Grid
        container
        spacing={2}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '60%', md: '60%' },
          maxHeight: { xs: '80vh', sm: '100vh', md: '100vh' },
          overflowY: 'auto',
          bgcolor: 'var(--dust-white)',
          p: 4,
        }}
      >
        <Grid size={12}>
          <Typography
            id='modal-modal-title'
            sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
          >
            {`${jid} Supply Selection`}
          </Typography>
        </Grid>
        {jid === 'California' && (
          <CaliforniaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Colorado' && (
          <ColoradoSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Connecticut' && (
          <ConnecticutSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Florida' && (
          <FloridaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Georgia' && (
          <GeorgiaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Indiana' && (
          <IndianaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Kentucky' && (
          <KentuckySupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Michigan' && (
          <MichiganSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Minnesota' && (
          <MinnesotaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Mississippi' && (
          <MississippiSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Missouri' && (
          <MissouriSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'New Jersey' && (
          <NewJerseySupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'New York' && (
          <NewYorkSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'North Carolina' && (
          <NorthCarolinaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'South Carolina' && (
          <SouthCarolinaSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Tennessee' && (
          <TennesseeSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Washington' && (
          <WashingtonSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        {jid === 'Wisconsin' && (
          <WisconsinSupplySelectForm
            supplySelections={supplySelections}
            setForm={setForm}
          />
        )}
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: 'var(--vega-blue)' }}
            onClick={handleClose}
          >
            {'Done'}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
